module.exports = __webpack_public_path__ + "img/craftBannerWaterConditioning.5324f96.webp";